import React,{useRef,useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import API from '../../API';
import MemberView from './MemberView';
import '../../App.css';
const PageApplicant =()=> {
    useEffect(() => {
        (async () => {

        })();

        return ()=>{ }
    }, []);
    return (
        <>
        <React.Fragment>
            <div className='container-fluuid'>
                <div className='row'>
                    <div className='col-12'>
                        <MemberView />
                    </div>
                </div>
            </div>
        </React.Fragment>
        </>
    )
}

export default React.memo(PageApplicant)
